<!-- CompactFinancialSection.vue -->
<template>
  <div class="compact-financial-section">
    <div class="section-header">
      <h4>{{ title }}</h4>
      <button 
        type="button" 
        @click="$emit('add-item')" 
        class="btn-add"
        :class="buttonClass"
      >
        + Add
      </button>
    </div>
    
    <!-- For Assets: Display by category -->
    <div v-if="type === 'asset' && itemsByCategory && Object.keys(itemsByCategory).length > 0" class="categories-wrapper">
      <div v-for="(categoryItems, category) in itemsByCategory" :key="category" class="category-group">
        <div class="category-header">
          <span class="category-name">{{ category }}</span>
          <span class="category-count">{{ categoryItems.length }}</span>
        </div>
        <div class="items-list">
          <CompactFinancialItem
            v-for="item in categoryItems"
            :key="`${category}-${item.originalIndex}`"
            :item="item"
            :index="item.originalIndex"
            :type="type"
            :item-category="itemCategory"
            @remove="$emit('remove-item', $event)"
            @update="$emit('update-item', $event, arguments[1], arguments[2])"
          />
        </div>
      </div>
    </div>
    
    <!-- For other types: Display flat list -->
    <div v-else-if="items.length > 0" class="items-list">
      <CompactFinancialItem
        v-for="item in items"
        :key="`${type}-${item.originalIndex}`"
        :item="item"
        :index="item.originalIndex"
        :type="type"
        :item-category="itemCategory"
        @remove="$emit('remove-item', $event)"
        @update="$emit('update-item', $event, arguments[1], arguments[2])"
      />
    </div>
    
    <div v-else class="empty-state">
      <p>No {{ title.toLowerCase() }} yet</p>
      <button 
        @click="$emit('add-item')" 
        class="btn-add-empty"
        :class="buttonClass"
      >
        + Add {{ buttonText }}
      </button>
    </div>
  </div>
</template>

<script>
import CompactFinancialItem from './CompactFinancialItem.vue';

export default {
  name: 'CompactFinancialSection',
  components: {
    CompactFinancialItem
  },
  props: {
    title: {
      type: String,
      required: true
    },
    type: {
      type: String,
      required: true,
      validator: value => ['income', 'expense', 'asset', 'liability'].includes(value)
    },
    items: {
      type: Array,
      required: true
    },
    itemsByCategory: {
      type: Object,
      default: null
    },
    itemCategory: {
      type: String,
      required: true,
      validator: value => ['cashflow', 'networth'].includes(value)
    }
  },
  emits: ['add-item', 'remove-item', 'update-item'],
  computed: {
    buttonClass() {
      return `${this.type}-btn`;
    },
    buttonText() {
      if (this.type === 'income' || this.type === 'expense') {
        return this.title;
      } else {
        return this.title.slice(0, -1); // Remove 's' from Assets/Liabilities
      }
    }
  }
};
</script>